<script setup lang="ts">
import { useConfigStore } from '@core/stores/config'
import { ContentWidth } from '@layouts/enums'

const configStore = useConfigStore()

// Icon mapping for different content widths
const getIcon = (width: string) => {
  return width === ContentWidth.Fluid ? 'bx-fullscreen' : 'bx-exit-fullscreen'
}

const getLabel = (width: string) => {
  return width === ContentWidth.Fluid ? 'Wide' : 'Compact'
}

const toggleContentWidth = () => {
  configStore.appContentWidth = configStore.appContentWidth === ContentWidth.Fluid
    ? ContentWidth.Boxed
    : ContentWidth.Fluid
}
</script>

<template>
  <IconBtn
    color="rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity))"
    @click="toggleContentWidth"
  >
    <VIcon
      :icon="getIcon(configStore.appContentWidth)"
      size="22"
    />

    <VTooltip
      activator="parent"
      open-delay="1000"
      scroll-strategy="close"
    >
      <span class="text-capitalize">{{ getLabel(configStore.appContentWidth) }} Mode</span>
    </VTooltip>
  </IconBtn>
</template>
